module.exports = __webpack_public_path__ + "static/media/medios-pago-vec-2.8e4037b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/medios-pago-vec-2.jpg
// module id = 796
// module chunks = 0